import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import CS2SkinMarketplace from './fe-smthsell';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <CS2SkinMarketplace />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals